import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController } from 'ionic-angular';
import { NoticesProvider } from '../../providers/notices/notices';
import { ToastProvider } from '../../providers/toast/toast';
import { PopoverPage } from '../popover/popover';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { EventDetailsPage } from '../event-details/event-details';


@IonicPage()
@Component({
  selector: 'page-events',
  templateUrl: 'event.html',
})
export class EventsPage {

  notices = [];
  searchNotice = [];
  showData = false;
  selRegistrationLogin  : any;
  tenant : any;
  noticeAr = []
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    private noticeProvider: NoticesProvider,
    private storage : Storage,
    private toast: ToastProvider,
    public popoverCtrl: PopoverController) {
    
    

    this.storage.get("loginDetails").then(val => {
     this.tenant = val.tenant == 0 ? 'owner' : 'tenant';
     console.log(this.tenant)
    });

      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }else{
        this.refresh()
  }
  }
  detailPage(notice: any) {
    if (notice.is_read == false) {
      notice.is_read = true;
      notice.set_read = true;
    }
    this.navCtrl.push(EventDetailsPage, {
      notice,
      title: this.translate.instant('EVENT_DETAIL')
    });
  }

  showNotices(data: any[]) {
    this.notices = [];
    let read = 0;
    data.forEach(item => {
      if (item.category == "EVENT" ) {
        // if (item.is_read == false) {
        //   this.notices.splice(read, 0, item);
        //   read++;
        // }
        // else {
        //   this.notices.push(item);
        // }
        this.notices.push(item);

      }
    });
    this.initializeItems();
  }

  doRefresh(refresher) {
    if(this.selRegistrationLogin){
    }
    else{
      this.refresh()
    }
    setTimeout(() => {
      this.showData = true;
      refresher.complete() 
    },2000)
  }

  refresh() {
    this.noticeAr = []
    this.noticeProvider.getEvents().then(val => {
      if (val.status == "success") {
        val.data.forEach((v) => {
          if(v.role){
            JSON.parse(v.role).forEach((ch) => {
              if(ch == this.tenant ){
                this.noticeAr.push(v)
              }
            });
          }else{
            this.noticeAr.push(v)
          }
        });
        this.showNotices(this.noticeAr);
        this.showData = true;
      } else {
      
        this.toast.presentToast("No actice Events found");
        this.showData = true;
      }
    });
  }

  presentPopover(myEvent) {
    
    if(this.selRegistrationLogin){
      this.showData = true
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    }else{
    let popover = this.popoverCtrl.create(PopoverPage, {
      parentPage: this,
      options: [
        {
          title: this.translate.instant('MARK_ALL_AS_READ'),
          handler: function (that) {
            that.noticeProvider.markAllRead().then(val => {
              if (val.status == "success") {
                that.toast.presentToast(val.message);
              } else {
                that.toast.presentToast("Unable to mark all");
              }
              that.refresh();
            });
          }
        },
      ]
    });
    popover.present({
      ev: myEvent
    });
  }
  }

  initializeItems() {
    this.searchNotice = this.notices;
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      return this.searchNotice = this.searchNotice.filter((item) => {
        return (item.subject.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  getPlainText(content: string) {
    return content.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, "");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventsPage');
  }

}





// WEBPACK FOOTER //
// ./src/pages/Event/event.ts